import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import Card from '../../UI/Card';
import ScheduleTimeline from '../Schedule/ScheduleTimeline';

// Read-only projection of the Schedule screen on Home overview
const SchedulePreview = ({ schedule, onOpenTest }) => {
    const { live, scheduled, conflicts } = schedule.counts;
    return (
        <Card variant="default" padding="none" className="overflow-hidden mb-6">
            <div className="flex items-center justify-between gap-5 px-6 pt-5 pb-4 border-b border-gray-100">
                <div className="flex items-center gap-4">
                    <h2 className="m-0 text-base font-bold text-stride-heading">Next 6 weeks</h2>
                    <span className="text-xs text-gray-500 font-medium">
                        {live} live · {scheduled} scheduled{conflicts ? ` · ${conflicts} conflict${conflicts > 1 ? 's' : ''}` : ''}
                    </span>
                </div>
                <Link className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary hover:text-primary-hover transition-colors whitespace-nowrap" to="/epm/schedule">
                    Open schedule <ArrowRight size={14} />
                </Link>
            </div>
            <ScheduleTimeline schedule={schedule} onOpenTest={onOpenTest} axisLabel="LOCATION" compact={true} />
        </Card>
    );
};

export default SchedulePreview;
